import debug from 'debug'
import * as React from 'react'
import { Redirect, Route } from 'react-router-dom'

import { ROUTE_AUTH_LOGIN } from '../screens/login/login.routes'

type TProps = NoChildren & {
  clearDataInMemory?: boolean
}

const log = debug('routing')

export const RedirectToLogin: React.FC<TProps> = ({
  clearDataInMemory = false,
}) => (
  <Route
    path={ROUTE_AUTH_LOGIN}
    children={({ match, location }) => {
      if (match) {
        return null
      }

      log('redirecting to login...')

      if (clearDataInMemory) {
        // clear the data in browser memory by reloading the whole app the hard way.
        // the auth cookie is removed synchronously on invalidation (via persistAuthModel's
        // onSnapshot), so there is no persistence race to wait for before reloading.
        window.location.href = `${window.location.origin}${ROUTE_AUTH_LOGIN}`

        return null
      }

      return (
        <Redirect
          to={{
            pathname: ROUTE_AUTH_LOGIN,
            state: { origin: location.pathname },
          }}
        />
      )
    }}
  />
)
